import './myCss.css'
import airbnb1 from './images/airbnbproj.jpg'
import videoDemo from './images/foodApp.mp4'
import movieDemo from './images/movie-recommender.mp4'
import TTS from './images/TTS.mp4'

const Projects = () => {
    return (
        <div className='grid-container'>
            <div className='grid-item'>
                <h4 id="latest">News Aggregator (beta demo)</h4>
                <video width="290" height="270" controls>
                    <source className="photo-project-1" src={TTS} type="video/mp4" />
                </video>

                <h5>Skills enhanced: API fetching, state managed components, React, route protection, and unit testing</h5>
                <h3 className="text"><a href="https://github.com/halujeff5/agg-proj" className='link-to-proj'
                    target="_blank" rel='noreferrer'>Frontend repo</a>

                    <a href="https://github.com/halujeff5/agg-proj-be" className='link-to-proj'
                        target="_blank" rel='noreferrer'>Backend repo</a>
                    <a href="https://frontpage-news-agg.onrender.com/" className='link-to-proj'
                        target="_blank" rel='noreferrer'>Project (orig.)</a>
                </h3>
            </div>
            <div className="grid-item">
                <h4 id="latest">Movie Recommender Using NLP</h4>
                <video width="290" height="270" controls>
                    <source className="photo-project-1" src={movieDemo} type="video/mp4" />
                </video>
                <h5>Skills enhanced: database seeding, webscraping, heavy backend logic, Flask jinja, Natural Language Processing</h5>

                <h3 className="text"><a className='link-to-proj' href="https://movie-recommender-mgdb2.onrender.com"
                    target="_blank" rel='noreferrer'>Movie
                    Geeks DB</a>
                    <a className='link-to-proj' href='https://github.com/jeffng5/Movie_Recommender'
                        target="_blank" rel='noreferrer'>repo</a>
                </h3>
            </div>

            <div className='grid-item'>
                <h4 id='latest'>Airbnb Reservation System</h4>

                <img className="photo-project-1" src={airbnb1} alt='airbinb'/>
                <h5>Skills enhanced: TypeScript, Material UI, UX, problem solving  </h5>
                <h3 className='text'><a className='link-to-proj' href = 'https://vimeo.com/1128137914?fl=ip&fe=ec' target= '_blank' rel= 'noreferrer'>Demo</a> <a
                    href='https://github.com/halujeff5/airbnb-property' target ='_blank' rel='noreferrer' className='link-to-proj'>repo</a></h3>

            </div>
            <div className='grid-item'>
                <h4 id='latest'>Recipe Finder in React Native</h4>
                <video width="290" height="250" controls>
                <source className="photo-project-1" src={videoDemo} type="video/mp4"/>
                </video>
                <h5>Skills enhanced: coding in new stack, learning about viewports, backend SQL querying</h5>
                <h3 className='text'>
                    <a className='link-to-proj'
                        href='https://github.com/jeffng5/culinary-rec-jn-frontend' target="_blank" rel='noreferrer'> Frontend repo</a>
                    <a className='link-to-proj'
                        href='https://github.com/jeffng5/culinary-rec-backend' target="_blank" rel='noreferrer'> Backend repo</a>
                    <a href="https://d3vy8uz718f5rd.cloudfront.net/" class='title-link'
                        target="_blank" rel='noreferrer'>Project</a>
                </h3>

            </div>
        </div>
    )
}





export default Projects
